var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Layout'),_c('div',{attrs:{"id":"CallCenter"}}),_c('div',{attrs:{"id":"callBackProcess"}},[_c('receive-caller'),_c('MyFeedback')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }